import { transactionsService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const PAGE_SIZE = 500;
// Safety cap so a very high-volume company can't trigger an unbounded number of requests.
const MAX_PAGES = 40;

// No backend aggregate endpoint exists, so we sum settled purchases client-side (paging through).
const useFetchCompanyTransactionsTotal = (companyId?: string) => {
  return useQuery({
    queryKey: ['fetchCompanyTransactionsTotal', companyId],
    queryFn: async () => {
      let page = 0;
      let total = 0;
      let totalCount = Infinity;

      while (page < MAX_PAGES && page * PAGE_SIZE < totalCount) {
        // eslint-disable-next-line no-await-in-loop
        const response = await transactionsService.fetchTransactions({
          companyIds: [companyId || ''],
          categories: ['PURCHASE'],
          status: ['SETTLED'],
          page,
          size: PAGE_SIZE,
        });

        totalCount = response.total;
        total += response.list.reduce((sum, transaction) => sum + (transaction.amount || 0), 0);
        page += 1;
      }

      return total;
    },
    enabled: !!companyId,
  });
};

export default useFetchCompanyTransactionsTotal;
